import http from 'conversations-http/clients/http';
import { mapUsersResponseToAtMentionUsers } from '../operators/mapUsersResponseToAtMentionUsers';
import { HS_INTERNAL_USER_ID, HS_OUT_OF_OFFICE_HOURS } from 'routing-ui/working-hours/constants';
import Raven from 'raven-js';
const getUserOutOfOfficeData = () => http.get('crm/v3/objects/0-115', {
  query: {
    properties: [HS_INTERNAL_USER_ID, HS_OUT_OF_OFFICE_HOURS]
  }
});
const getUsers = ({
  inboxId
}) => http.get(`messages/v2/users`, {
  query: {
    inboxId,
    includeSecondaryTeamMembers: true
  }
});
export const getAtMentionsCapabilityData = ({
  inboxId
}) => {
  const usersWithWorkingHoursPromise = getUserOutOfOfficeData().catch(e => {
    Raven.captureException(e);
    return {
      results: []
    };
  });
  const usersPromise = getUsers({
    inboxId
  }).catch(e => {
    Raven.captureException(e);
    return {
      routableUsers: [],
      freeUsers: [],
      adminUsers: []
    };
  });
  return Promise.all([usersPromise, usersWithWorkingHoursPromise]).then(([atMentionUsers, usersWithWorkingHours]) => ({
    users: mapUsersResponseToAtMentionUsers(atMentionUsers, usersWithWorkingHours)
  }));
};